/**
 * Club / host venue — public profile + events.
 */
import { postHostProfile } from "./apiService";
import { isApiSuccess } from "../utils/clubDetailHelpers";

/**
 * Load host profile + events list (banner, logo, business name, address from `host`).
 * @param {string} hostId
 * @returns {Promise<{ ok: boolean, data: object | null, message: string }>}
 */
export async function fetchHostProfile(hostId) {
  const res = await postHostProfile(hostId);
  if (!isApiSuccess(res.status)) {
    return {
      ok: false,
      data: null,
      message: res.message || "Unable to load host profile",
    };
  }

  const host = res.host;
  const events = Array.isArray(res.events) ? res.events : [];

  if (!host || typeof host !== "object") {
    return {
      ok: false,
      data: null,
      message: res.message || "No host data",
    };
  }

  /** Single object for page helpers: host fields + nested `events`. */
  const data = {
    ...host,
    name: host.businessName,
    clubName: host.businessName,
    events,
  };

  return {
    ok: true,
    data,
    message: "",
  };
}
